import { create } from 'zustand';
import { getUsers, createUser, updateUser, deleteUser } from '../services/adminService';

const useUserStore = create((set, get) => ({
  users: [],
  loading: false,
  error: null,

  fetchUsers: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getUsers();
      set({ users: data, loading: false });
    } catch (error) {
      set({ error: error, loading: false });
    }
  },

  addUser: async (userData) => {
    set({ loading: true, error: null });
    try {
      await createUser(userData);
      await get().fetchUsers(); // Refetch all users
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  updateUser: async (id, userData) => {
    set({ loading: true, error: null });
    try {
      await updateUser(id, userData);
      await get().fetchUsers(); // Refetch all users
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },

  removeUser: async (id) => {
    set({ loading: true, error: null });
    try {
      await deleteUser(id);
      set((state) => ({
        users: state.users.filter((u) => u.id !== id),
        loading: false,
      }));
    } catch (error) {
      set({ error: error, loading: false });
      throw error; // Re-throw to allow component to handle
    }
  },
}));

export default useUserStore;
